module.exports = __webpack_public_path__ + "static/media/photo213.f050fc63.jpg";